import OrderHightAmount from "../../components/react-table/order-maintenance";

function OrdenesHighAmount() {
  return (
    <div>
      <OrderHightAmount contextmenu="visualmontos" />
    </div>
  );
}

export default OrdenesHighAmount;
